import { makeStyles, shorthands } from '@fluentui/react-components';
import videopageBanner from '../../video-page-styles/image-asset/videopageBanner.png';

export const useVideoPageTopBannerContainerStyle = makeStyles({
  topBanner: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    ...shorthands.padding('36px'),
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...shorthands.gap('24px'),
    alignSelf: 'stretch',
    ...shorthands.borderRadius('8px'),
    backgroundImage: `url(${videopageBanner})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  texts: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('8px'),
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    textAlign: 'left',
  },
  pageName: {
    lineHeight: '37px',
    fontSize: '28px',
    fontWeight: 600,
  },
  descriptions: {
    fontSize: '16px',
    lineHeight: '21px',
    fontWeight: 400,
  },
  entryCard: {
    width: '100%',
  },
});
